export var comma = function (input) {
    return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
//# sourceMappingURL=filter.js.map